import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BrowserName, DeviceType } from '../../services/pwa-service.service';

@Component({
    selector: 'app-manual-install-dialog',
    standalone: true,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatDialogTitle,
        MatStepperModule,
    ],
    templateUrl: './manual-install-dialog.component.html',
    styleUrl: './manual-install-dialog.component.scss'
})
export class ManualInstallDialogComponent implements OnInit{
  browserName!: BrowserName;
  deviceType!: DeviceType;
  isIOS!: boolean;

  public appIsInstallable : boolean = true;
  public notification : string | undefined = undefined;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { deviceType: DeviceType, browserName: BrowserName, isIOS: boolean }) {
    this.browserName = data.browserName;
    this.deviceType = data.deviceType;
    this.isIOS = data.isIOS;
  }

  public steps: Array<{ name: string; image: string, message?:string }> = [];

  ngOnInit(): void {
    if (!this.browserName || !this.deviceType) {
      throw new Error('DynamicStepperComponent: `browserName` und `deviceType` sind Pflicht-Inputs.');
    }
    this.setSteps();
  }

  private setSteps(): void {
    if (this.browserName === BrowserName.Firefox && this.deviceType === DeviceType.Mobile && !this.isIOS) {
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/firefox_mobile_1_box.png'}, 
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/firefox_mobile_2_box.png'}, 
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/firefox_mobile_3_box.png'}, 
      ];
    } else if (this.browserName === BrowserName.Firefox && this.deviceType === DeviceType.Mobile && this.isIOS) {
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/firefox_iphone_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/firefox_iphone_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/firefox_iphone_3_box.png' },
        { name: 'Schritt 4', image: 'assets/images/Install_Guide/firefox_iphone_4_box.png' }
      ];
    } else if (this.browserName === BrowserName.Safari && this.deviceType === DeviceType.Mobile && this.isIOS) {
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/safari_mobile_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/safari_mobile_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/safari_mobile_3_box.png' },
      ];
    } else if (this.browserName === BrowserName.Edge && this.deviceType === DeviceType.Mobile && this.isIOS) {
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/edge_iphone_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/edge_iphone_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/edge_iphone_3_box.png' },
        { name: 'Schritt 4', image: 'assets/images/Install_Guide/edge_iphone_4_box.png' }
      ];
    } else if (this.browserName === BrowserName.Chrome && this.deviceType === DeviceType.Mobile && this.isIOS) { 
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/chrome_iphone_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/chrome_iphone_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/chrome_iphone_3_box.png' }
      ];
    } else if (this.browserName === BrowserName.Firefox && this.deviceType === DeviceType.Tablet && !this.isIOS) {
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/firefox_tablet_1_box.png'},
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/firefox_tablet_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/firefox_tablet_3_box.png' },
      ];
    } else if (this.browserName === BrowserName.Firefox && this.deviceType === DeviceType.Tablet && this.isIOS) {
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/firefox_ipad_1_box.png'},
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/firefox_ipad_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/firefox_ipad_3_box.png' },
      ];
    } else if (this.browserName === BrowserName.Safari && this.deviceType === DeviceType.Tablet && this.isIOS) { 
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/safari_ipad_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/safari_ipad_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/safari_ipad_3_box.png' },
      ];
    } else if (this.browserName === BrowserName.Edge && this.deviceType === DeviceType.Tablet && this.isIOS) { 
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/edge_ipad_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/edge_ipad_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/edge_ipad_3_box.png' },
      ];
    } else if (this.browserName === BrowserName.Chrome && this.deviceType === DeviceType.Tablet && this.isIOS) { 
      this.appIsInstallable = true;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/chrome_ipad_1_box.png' },
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/chrome_ipad_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/chrome_ipad_3_box.png' },
      ];
    } 

    // Fallback für Browser-Gätkombinationen ohne Guide
    else if (this.deviceType === DeviceType.Mobile) {
      this.appIsInstallable = true;
      this.notification = `Leider existiert aktuell noch keine Anleitung für das Installieren der App für den Browser ${this.browserName} auf Mobilgeräten. Das Vorgehen zum Installieren der App kann daher von den hier beschriebenen Schritten abweichen.`;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/firefox_mobile_1_box.png'}, // , message: 'Klicken Sie auf das Menu-Symbol in Ihrem Browser.' 
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/firefox_mobile_2_box.png'}, // , message: 'Klicken Sie auf "Zum Startbildschirm hinzufügen".'
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/firefox_mobile_3_box_mod.png'}, // , message: 'Klicken Sie auf "Zum Startbildschirm hinzufügen".' 
      ];
    } else if (this.deviceType === DeviceType.Tablet) {
      this.appIsInstallable = true;
      this.notification = `Leider existiert aktuell noch keine Anleitung für das Installieren der App für den Browser ${this.browserName}. Das Vorgehen zum Installieren der App kann daher von den hier beschriebenen Schritten abweichen.`;
      this.steps = [
        { name: 'Schritt 1', image: 'assets/images/Install_Guide/firefox_tablet_1_box.png'},
        { name: 'Schritt 2', image: 'assets/images/Install_Guide/firefox_tablet_2_box.png' },
        { name: 'Schritt 3', image: 'assets/images/Install_Guide/firefox_tablet_3_box.png' },
      ];
    } else {
      this.appIsInstallable = false;
      this.notification = `Leider existiert aktuell keine Anleitung für das Installieren der App für den Browser ${this.browserName} auf Ihrem Gerät.`;
    }
  }
}